import cx from 'classnames';

/**
 * Internal Dependencies
 */
import IconClose from '@/assets/svg-icons/icon-close';
import IconHouse from '@/assets/svg-icons/icon-house';
import ResponsiveImage from '@/common/components/responsive-image/responsive-image';

const AddPropertiesList = ({
    properties,
    activePropertyId,
    onPropertyDelete = () => {},
    onPropertyEdit = () => {},
}) => {
    if (!properties) return null;

    return (
        <div className="add-properties__list">
            {properties.map((property) => (
                <div className="add-properties__list-row" key={property.id}>
                    <div
                        className={cx('add-properties__list-card', {
                            'is-active': activePropertyId === property.id,
                        })}
                    >
                        <figure>
                            {!!property.attachment ? (
                                <ResponsiveImage
                                    className="full-overlay"
                                    src={property.attachment}
                                    alt={property.listing_name || property.airbnb_address}
                                />
                            ) : (
                                <IconHouse />
                            )}
                        </figure>

                        <p className="overflow-truncate">{property.listing_name || property.airbnb_address}</p>

                        {!property.verified && <span className="callout-badge">Pending</span>}

                        {/* <button type="button" onClick={() => onPropertyDelete(property.id, property.verified)}>
                            <IconClose />
                        </button> */}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AddPropertiesList;
